import React, { useContext, useEffect, useState } from 'react'
import { RevalidationCheckPinCodeTemplate } from '../../templates/RevalidationCheckPinCodeTemplate'

import PropTypes from 'prop-types'
import { CountdownContext } from '../../../util/providers/CountdownProvider'
import {
  getMaskedValue as getMaskedPhone,
  removeMask as removePhoneMask,
  isLandline,
  isValid as isValidPhone,
} from '../../../util/PhonePattern'
import { sendPinCode, confirmationCheckPinCode, checkPinCode } from '../../../api/pinCodeApi'
import { revalidationCheckAttempts } from '../../../api/attemptCheckAPI'
import { handleRevalidationPinCodePhoneExceptions } from './revalidationCheckPicCodePhoneExceptions'
import { formatedTime } from '../../../util/date'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'

const defaultRemainingAttempts = 4

export const RevalidationPhoneCheckPinCodePage = ({
  onBackClick,
  onSuccess,
  redirectOnPhoneConflict,
}) => {
  const { token, phone, updateEmailsInUse, updatePinCode, lurker } = useContext(RevalidationContext)
  const { lockTime, checkAttemptLockTime } = useContext(CountdownContext)

  const [remainingAttempts, setRemainingAttempts] = useState(defaultRemainingAttempts)
  const [isResending, setIsResending] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showResendCodeSuccessMessage, setShowResendCodeSuccessMessage] = useState(false)
  const [error, setError] = useState(null)

  const handleSuccess = phone => {
    onSuccess(removePhoneMask(phone))
  }

  const onPhoneConflict = (emails, pincode) => {
    updateEmailsInUse(emails)
    updatePinCode(pincode)
    redirectOnPhoneConflict()
  }

  const onResend = () => checkAttemptLockTime(checkAttempt)

  const onResendCodeSuccess = eventName => {
    lurker.viewMessageEvt(eventName)
    setShowResendCodeSuccessMessage(true)
    setIsResending(false)
  }

  const resendCode = () => {
    const phoneValue = getMaskedPhone(phone.value).clean
    const newPhone = isValidPhone(phoneValue) ? phoneValue : null
    const landline = isLandline(phone.value)

    const typeRequest = {
      clickEvt: landline ? 'make_call' : 'resend_sms',
      eventName: landline ? 'make_call_success' : 'resend_sms_success',
      eventNameError: landline ? 'make_call_error' : 'resend_sms_error',
    }

    setIsResending(true)

    lurker.clickEvt(typeRequest.clickEvt)

    sendPinCode(newPhone, 'PHONE', token)
      .then(() => onResendCodeSuccess(typeRequest.eventName))
      .catch(error => onPinCodeError(error, typeRequest.eventNameError, ''))
      .finally(() => {
        if (typeof onResend === 'function') {
          onResend()
        }
      })
  }

  const onPinCodeError = (error = {}, eventName = 'error', pincode = '') => {
    const {
      response: {
        status,
        data: {
          message = '',
          current_email: email = '',
          conflicts: emails = [],
          details = { ttl: 0, attempts: 2, max_attempts: 4, remaining_attempts: 2 },
        } = {},
      } = {},
    } = error

    if (status === 403 && message === 'PHONE_IN_USE') {
      onPhoneConflict(emails, pincode)
    }

    const pinCodeLockTime = details.ttl
    setRemainingAttempts(details.remaining_attempts)
    const { errorInfo, lurkerExtraData } = handleRevalidationPinCodePhoneExceptions(
      error,
      remainingAttempts
    )

    setError({
      ...errorInfo,
      message: errorInfo.message?.replace(/{LOCK_TIME}/, formatedTime(pinCodeLockTime)),
    })

    lurker.viewMessageEvt(eventName, { ...lurkerExtraData })
  }

  const checkAttemptLockTimeCallback = () => revalidationCheckAttempts(token)

  const onPinCodeChange = (pinCode, isValid) => {
    const phoneValue = getMaskedPhone(phone.value).clean
    const newPhone = isValidPhone(phoneValue) ? phoneValue : null
    const isChangedPhone = !phoneValue.includes('*')

    if (isValid) {
      lurker.clickEvt('submit')
      setIsSubmitting(true)

      const checkPromise = isChangedPhone
        ? checkPinCode(newPhone, 'PHONE', pinCode, 'AccountsValhallaRevalidation', token)
        : confirmationCheckPinCode(pinCode, token, 'PHONE')

      checkPromise
        .then(onCheckPinCodeSuccess)
        .catch(error => onPinCodeError(error, 'error', pinCode))
        .finally(() => setIsSubmitting(false))
    }
  }

  const closeResendCodeSuccessMessage = () => {
    setShowResendCodeSuccessMessage(true)
  }

  const onCheckPinCodeSuccess = () => {
    lurker.viewMessageEvt('success')
    setIsSubmitting(false)

    handleSuccess(getMaskedPhone(phone.value).clean)
  }

  useEffect(() => {
    lurker.pageLoadEvt('revalidate_phone_check')
    checkAttemptLockTime(checkAttemptLockTimeCallback)
  }, [])

  return (
    <RevalidationCheckPinCodeTemplate
      title="Confirme o seu telefone"
      description="Digite o código enviado por SMS para"
      alertDescription="O código é privado. Não compartilhe essa informação com ninguém."
      infoDescription="Deseja reenviar o código para o número"
      data={getMaskedPhone(phone.value).pretty}
      lockTime={lockTime}
      remainingAttempts={remainingAttempts}
      error={error}
      isResending={isResending}
      resendCode={resendCode}
      onPinCodeChange={onPinCodeChange}
      closeResendCodeSuccessMessage={closeResendCodeSuccessMessage}
      onBack={onBackClick}
      isSubmitting={isSubmitting}
      showResendCodeSuccessMessage={showResendCodeSuccessMessage}
    />
  )
}

RevalidationPhoneCheckPinCodePage.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  redirectOnPhoneConflict: PropTypes.func,
}
